import React from 'react';
import studioStyles from '../environments/StudioModal.module.scss';

type StudioButtonVariant = 'primary' | 'outline';
type StudioButtonSize = 'sm' | 'md';

export function StudioButton({
  children,
  onClick,
  disabled,
  variant = 'primary',
  size = 'md',
  startIcon,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: StudioButtonVariant;
  size?: StudioButtonSize;
  startIcon?: React.ReactNode;
}) {
  const className =
    variant === 'primary'
      ? `${studioStyles.button} ${studioStyles.primaryButton}`
      : `${studioStyles.button} ${studioStyles.outlineButton}`;

  const style: React.CSSProperties | undefined =
    size === 'sm' ? { height: 32, padding: '0 12px', fontSize: 13 } : undefined;

  return (
    <button type="button" className={className} onClick={onClick} disabled={disabled} style={style}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {startIcon ? <span style={{ display: 'inline-flex', alignItems: 'center' }}>{startIcon}</span> : null}
        {children}
      </span>
    </button>
  );
}
